export default __webpack_public_path__ + "static/support-sponsor-destina-678b945316f215095d00c114270aa3b3.png";